/*
  Product add-on checkboxes (snippets/product-addons.liquid). Loaded on every page
  (layout/theme.liquid) so they also work in quick view.

  When any add-on is ticked, this takes over the product form's submit and adds the knife and
  its add-ons in one /cart/add.js request. Each add-on is nested under the knife's cart line
  with parent_id (Shopify nested cart lines), so cart, checkout and the order show it as part
  of that knife, and removing the knife removes its add-ons. Each add-on line also carries
  properties[For] = knife title as a readable note.

  Engraving isn't a cart line (Oct 19, 2026): ticking it saves "Engraving" and "Engraving Text"
  on the knife's own line, so there's no free item that can be ordered on its own.

  A set (Macrum Set, Nov 2, 2026) has its own two rows: Engraving with a field per knife, saved on the set's
  line as "Engraving - <knife>" and as a cart attribute, and Sayas with a box per saya, added as their own
  lines (never nested: Shopify drops lines nested under a bundle at checkout).

  If that request is refused while the knife is already in the cart (a one-of-one can only be
  in the cart once), the ticked add-ons go under the knife's existing line instead, and the
  cart opens as usual (Oct 16, 2026). Before, the add-ons were dropped with the refusal.
*/
(function () {
  if (window.productAddonsInit) return;
  window.productAddonsInit = true;

  // Add-ons and form must share a product section (page or quick view), so a cart form
  // elsewhere on the page never picks up another product's ticked extras.
  function sectionOf(el) {
    return el.closest('[data-section-type="product"]');
  }

  function addonsFor(form) {
    var section = sectionOf(form);
    return section && section.querySelector('[data-product-addons]');
  }

  function formFor(root) {
    var section = sectionOf(root);
    return section && section.querySelector('form[action*="/cart/add"]');
  }

  function engravingText(root) {
    var input = root.querySelector('[data-engraving-input]');
    return input ? input.value.trim() : '';
  }

  function engravingChecked(root) {
    return !!root.querySelector('[data-addon-engraving]:checked');
  }

  // A set's Engraving row (Nov 2, 2026): one field per knife.
  function setEngravingChecked(root) {
    return !!root.querySelector('[data-set-engraving]:checked');
  }

  // The set's filled engraving fields, as [{ knife, text }].
  function setEngravings(root) {
    if (!setEngravingChecked(root)) return [];
    var list = [];
    Array.prototype.forEach.call(root.querySelectorAll('[data-set-engraving-input]'), function (input) {
      var text = input.value.trim();
      if (text) list.push({ knife: input.dataset.knife, text: text });
    });
    return list;
  }

  // Engraving is left out: it's saved on the knife's (or set's) own line (knifeItem).
  // A set's Sayas row (data-addon-parts, Nov 2, 2026) adds each ticked saya, marked separate: they aren't nested
  // under the set, because Shopify drops lines nested under a bundle at checkout.
  function selectedAddons(root) {
    var forKnife = root.dataset.knifeTitle;
    var items = [];
    Array.prototype.forEach.call(root.querySelectorAll('[data-addon]:checked:not([data-addon-engraving]):not([data-set-engraving])'), function (checkbox) {
      if (checkbox.hasAttribute('data-addon-parts')) {
        var row = checkbox.closest('.product-addons__row');
        Array.prototype.forEach.call(row.querySelectorAll('[data-addon-part]:checked:not(:disabled)'), function (part) {
          items.push({ id: Number(part.value), quantity: 1, properties: { For: forKnife }, separate: true });
        });
        return;
      }
      items.push({ id: Number(checkbox.value), quantity: 1, properties: { For: forKnife } });
    });
    return items;
  }

  // A price in cents as the store shows it, without ".00" ($160, $45.50).
  function priceText(cents) {
    var amount = (cents / 100).toLocaleString('en-US', {
      minimumFractionDigits: cents % 100 ? 2 : 0,
      maximumFractionDigits: 2
    });
    var format = (window.theme && theme.settings && theme.settings.moneyFormat) || '${{amount}}';
    return format.replace(/\{\{\s*\w+\s*\}\}/, amount);
  }

  // The Sayas row's price follows its ticked boxes.
  function updatePartsTotal(row) {
    var total = 0;
    Array.prototype.forEach.call(row.querySelectorAll('[data-addon-part]:checked:not(:disabled)'), function (part) {
      total += Number(part.dataset.price);
    });
    var price = row.querySelector('[data-addon-parts-total]');
    if (price) price.textContent = priceText(total);
  }

  // The set's engraving also goes in a cart attribute ("Macrum Set engraving: Burnside Chef: ABC, ..."), which
  // shows in the order's Additional details even if Shopify doesn't carry the bundle line's properties through.
  // A second engraved set in the same cart gets "(2)", and so on. Never blocks the add.
  function saveSetEngraving(root, engravings) {
    if (!engravings.length) return Promise.resolve();
    var text = engravings
      .map(function (engraving) {
        return engraving.knife + ': ' + engraving.text;
      })
      .join(', ');
    var base = root.dataset.knifeTitle + ' engraving';
    return fetch(theme.routes.cartPage + '.js')
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        var attributes = cart.attributes || {};
        var key = base;
        var n = 2;
        while (attributes[key]) {
          key = base + ' (' + n + ')';
          n++;
        }
        var update = {};
        update[key] = text;
        return fetch(theme.routes.cartPage + '/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes: update })
        });
      })
      .catch(function () {});
  }

  function knifeItem(form, root) {
    var item = { quantity: 1, properties: {} };
    new FormData(form).forEach(function (value, key) {
      var property = key.match(/^properties\[(.+)\]$/);
      if (key === 'id') item.id = Number(value);
      else if (key === 'quantity') item.quantity = Number(value);
      else if (key === 'selling_plan' && value) item.selling_plan = Number(value);
      else if (property) item.properties[property[1]] = value;
    });
    if (engravingChecked(root)) {
      item.properties['Engraving'] = 'Yes';
      item.properties['Engraving Text'] = engravingText(root);
    }
    setEngravings(root).forEach(function (engraving) {
      item.properties['Engraving - ' + engraving.knife] = engraving.text;
    });
    return item;
  }

  function showError(form, message) {
    var existing = form.querySelector('.errors');
    if (existing) existing.remove();
    var div = document.createElement('div');
    div.className = 'errors text-center';
    div.textContent = message;
    form.append(div);
  }

  function addItems(items) {
    return fetch(theme.routes.cartAdd, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (response) {
      return response.json();
    });
  }

  function knifeLine(cart, knife) {
    return cart.items.find(function (item) {
      return !item.parent_relationship && item.variant_id === knife.id;
    });
  }

  // Saves ticked engraving on the knife's line already in the cart. The line gets a new key and
  // its nested add-ons move with it (tested Oct 19, 2026). Resolves to the cart.
  function engraveLine(cart, line, knife) {
    if (!knife.properties['Engraving']) return Promise.resolve(cart);
    var properties = Object.assign({}, line.properties, {
      'Engraving': knife.properties['Engraving'],
      'Engraving Text': knife.properties['Engraving Text']
    });
    return fetch(theme.routes.cartChange, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: line.key, quantity: line.quantity, properties: properties })
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        return data.status ? cart : data;
      });
  }

  // Adds the add-ons under the knife's line already in the cart, skipping any already there,
  // and saves ticked engraving on that line. Resolves to null when the knife isn't in the cart.
  function addToKnifeInCart(knife, addons) {
    return fetch(theme.routes.cartPage + '.js')
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        var line = knifeLine(cart, knife);
        return line ? engraveLine(cart, line, knife) : null;
      })
      .then(function (cart) {
        if (!cart) return null;
        var line = knifeLine(cart, knife);

        var items = addons
          .filter(function (addon) {
            return !cart.items.some(function (item) {
              return item.variant_id === addon.id && item.parent_relationship && item.parent_relationship.parent_key === line.key;
            });
          })
          .map(function (addon) {
            return { id: addon.id, quantity: addon.quantity, properties: addon.properties, parent_line_key: line.key };
          });
        if (!items.length) return { items: [line] };

        return addItems(items).then(function (data) {
          return data.status ? data : { items: [line] };
        });
      });
  }

  // "What's this?" shows or hides an add-on's description.
  document.addEventListener('click', function (evt) {
    var button = evt.target.closest('[data-addon-more]');
    if (!button) return;
    var info = document.getElementById(button.getAttribute('aria-controls'));
    var open = button.getAttribute('aria-expanded') !== 'true';
    button.setAttribute('aria-expanded', open ? 'true' : 'false');
    info.hidden = !open;
  });

  // A set's engraving fields: typing clears the "at least one knife" message.
  document.addEventListener('input', function (evt) {
    if (!evt.target.matches('[data-set-engraving-input]')) return;
    var row = evt.target.closest('.product-addons__row');
    Array.prototype.forEach.call(row.querySelectorAll('[data-set-engraving-input]'), function (input) {
      input.setCustomValidity('');
    });
  });

  // Ticking Engraving reveals its text field; Buy it now is hidden while extras are ticked.
  // A set's rows: Engraving opens a field per knife; Sayas opens a box per saya, all ticked, and unticking
  // the last one unticks the row.
  document.addEventListener('change', function (evt) {
    if (evt.target.matches('[data-addon-part]')) {
      var partsRow = evt.target.closest('.product-addons__row');
      updatePartsTotal(partsRow);
      if (!partsRow.querySelector('[data-addon-part]:checked:not(:disabled)')) {
        var partsBox = partsRow.querySelector('[data-addon-parts]');
        partsBox.checked = false;
        partsBox.dispatchEvent(new Event('change', { bubbles: true }));
      }
      return;
    }

    if (!evt.target.matches('[data-addon]')) return;

    var row = evt.target.closest('.product-addons__row');
    var details = row.querySelector('[data-addon-details]');
    if (details) details.hidden = !evt.target.checked;

    var input = row.querySelector('[data-engraving-input]');
    if (input) {
      input.disabled = !evt.target.checked;
      input.required = evt.target.checked;
      if (evt.target.checked) input.focus();
      else input.value = '';
    }

    if (evt.target.matches('[data-addon-parts]') && evt.target.checked) {
      Array.prototype.forEach.call(row.querySelectorAll('[data-addon-part]:not(:disabled)'), function (part) {
        part.checked = true;
      });
      updatePartsTotal(row);
    }

    var setInputs = row.querySelectorAll('[data-set-engraving-input]');
    Array.prototype.forEach.call(setInputs, function (setInput) {
      setInput.disabled = !evt.target.checked;
      setInput.setCustomValidity('');
      if (!evt.target.checked) setInput.value = '';
    });
    if (setInputs.length && evt.target.checked) setInputs[0].focus();

    var root = evt.target.closest('[data-product-addons]');
    var form = formFor(root);
    var buyNow = form && form.querySelector('.shopify-payment-button');
    if (buyNow) buyNow.hidden = root.querySelectorAll('[data-addon]:checked').length > 0;
  });

  // Capture phase on document runs before the theme's own submit handler on the form.
  document.addEventListener(
    'submit',
    function (evt) {
      var form = evt.target;
      if (!form.matches('form[action*="/cart/add"]')) return;

      var root = addonsFor(form);
      if (!root) return;

      var addons = selectedAddons(root);
      if (!addons.length && !engravingChecked(root) && !setEngravingChecked(root)) return;

      evt.preventDefault();
      evt.stopImmediatePropagation();

      var input = root.querySelector('[data-engraving-input]');
      if (input && !input.disabled && !input.checkValidity()) {
        input.reportValidity();
        return;
      }

      // A set's Engraving: each filled field must be valid, and at least one knife filled in.
      if (setEngravingChecked(root)) {
        var setInputs = root.querySelectorAll('[data-set-engraving-input]');
        var invalid = Array.prototype.find.call(setInputs, function (setInput) {
          return !setInput.checkValidity();
        });
        if (invalid) {
          invalid.reportValidity();
          return;
        }
        if (!setEngravings(root).length) {
          setInputs[0].setCustomValidity('Add up to three characters for at least one knife, or untick Engraving.');
          setInputs[0].reportValidity();
          return;
        }
      }
      var engravings = setEngravings(root);

      var button = form.querySelector('[data-add-to-cart]');
      button.classList.add('btn--loading');

      var knife = knifeItem(form, root);
      var nested = [];
      addons.forEach(function (addon) {
        if (addon.separate) {
          delete addon.separate;
        } else {
          addon.parent_id = knife.id;
          nested.push(addon);
        }
      });

      addItems([knife].concat(addons))
        .then(function (data) {
          if (!data.status) return data;
          return addToKnifeInCart(knife, nested).then(function (added) {
            if (!added) return data;
            // The refusal still shows (as the theme shows it for a knife already in the cart).
            if (!added.status) added.notice = data.description || data.message;
            return added;
          });
        })
        .then(function (data) {
          // The set's engraving attribute is saved only when the set itself went in.
          if (data.status || data.notice) return data;
          return saveSetEngraving(root, engravings).then(function () {
            return data;
          });
        })
        .then(function (data) {
          button.classList.remove('btn--loading');

          if (data.status) {
            showError(form, data.description || data.message);
            return;
          }

          var existing = form.querySelector('.errors');
          if (existing) existing.remove();
          if (data.notice) showError(form, data.notice);

          if (theme.settings.cartType === 'page') {
            window.location = theme.routes.cartPage;
            return;
          }

          form.dispatchEvent(
            new CustomEvent('ajaxProduct:added', {
              detail: { product: data.items[0], addToCartBtn: button },
              bubbles: true
            })
          );
        });
    },
    true
  );
})();
